export default "__VITE_ASSET__40a38435__"